import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import session from '../../../../share/session';
import { REQUEST_STATUS_COMPLETED } from '../../../../../../share/src/util/api/polling';
import { PHASE, ADJUSTMENT_STATUS } from './constants';
import { terminate } from './terminate';

/** 
 * ルーチン実行・結果確認
 * @param {object} self this インスタンス
 * @param {boolean} isErrorDisp エラー画面からの遷移判定
 */
export async function read(self, isErrorDisp) {
  try {
    self.isLoading = true;
    // バックエンドAPI POST,GET
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'read',
        isErrorDisp: isErrorDisp
      },
      // エラー発生のコールバックを実装
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
    );

    if (!response) {
      // pollingWspApiはエラーコールバックの終了を待たずnullを返す
      // 非同期処理を含んでいるshowUnexpectedErrorが呼ばれた場合、スピナー消えてしまうためPromiseの解決を待つ
      if (self.exitPromise) await self.exitPromise;
      return;
    }

    // 正常コールバック
    if (response.data?.status === REQUEST_STATUS_COMPLETED) {
      const userData = response.data.user_data;
      let filteredUserData = {};
      let readOutData = "";
      let resultAry = [];
      switch (self.adjustmentStatus) {
        case ADJUSTMENT_STATUS.ADJUSTMENT_OK:
          // 軸調整OKの場合、DIDのByte5要素を取得
          filteredUserData = { readout_data: userData.readout_data.filter(item => item.did.charAt(5) === "5") };
          // 表示用DID編集処理
          readOutData = await individualWorkSupportUtil.getReadOutData(self, self.systemId, filteredUserData);
          // DID編集後のデータから、値と単位のみ取得
          self.successReadValue = readOutData ? readOutData.split(':')[1] : '';
          break;
        case ADJUSTMENT_STATUS.ADJUSTMENT_NG:
          // 軸調整NGの場合、DIDのByte7,9要素を取得
          filteredUserData = { readout_data: userData.readout_data.filter(item => item.did.charAt(5) === "7" || item.did.charAt(5) === "9") };
          // 表示用DID編集処理
          readOutData = await individualWorkSupportUtil.getReadOutData(self, self.systemId, filteredUserData);
          // ルーチン実行で取得した水平結果・垂直結果の判定
          self.routineStatus1 = self.horizontalStatus ? self.$t(`${self.i18nWsKey}.routine_status1_${self.horizontalStatus.toUpperCase()}`) : '';
          self.routineStatus2 = self.verticalStatus ? self.$t(`${self.i18nWsKey}.routine_status2_${self.verticalStatus.toUpperCase()}`) : '';
          if (readOutData) {
            // DID編集後のデータから、値と単位のみ取得
            resultAry = readOutData.split('\n');
            // 水平方向 判定値（正常範囲内（0x00）の場合、"OK"固定表示、それ以外はDID値表示）
            self.ngReadValue1 = self.horizontalStatus === "00" ? self.$t('message.common_button_ok') : resultAry[0] ? resultAry[0].split(':')[1] : '';
            // 垂直方向 判定値（正常範囲内（0x00）の場合、"OK"固定表示、それ以外はDID値表示）
            self.ngReadValue2 = self.verticalStatus === "00" ? self.$t('message.common_button_ok') : resultAry[1] ? resultAry[1].split(':')[1] : '';
          }
          break;
        case ADJUSTMENT_STATUS.ADJUSTMENT_FAILED:
          // エラー処理の場合、DIDのByte1,2,3要素を取得
          filteredUserData = { readout_data: userData.readout_data.filter(item => item.did.charAt(5) === "1" || item.did.charAt(5) === "2" || item.did.charAt(5) === "3") };
          // 表示用DID編集処理
          readOutData = await individualWorkSupportUtil.getReadOutData(self, self.systemId, filteredUserData);
          if (readOutData) {
            // DID編集後のデータから、値と単位のみ取得
            resultAry = readOutData.split('\n');
            // 車速有無
            self.failedReadValue1 = resultAry[0] ? resultAry[0].split(':')[1] : '';
            // DTC/UDMDTC発生有無
            self.failedReadValue2 = resultAry[1] ? resultAry[1].split(':')[1] : '';
            // SRVD or BSW/RCTW状態
            self.failedReadValue3 = resultAry[2] ? resultAry[2].split(':')[1] : '';
          }
          break;
        default:
          break;
      }

      // Terminate処理のAPI実行
      await terminate(self);
      // 遷移先画面を振り分け
      await moveNextPhase(self);
    } else {
      // 共通エラー
      await self.showUnexpectedError();
    }
  } finally {
    self.isLoading = false;
  }
}

/**
  * 遷移先画面を振り分け
  * @param {object} self this インスタンス
  */
async function moveNextPhase(self) {
  // 調整結果で遷移先画面を振り分け
  switch (self.adjustmentStatus) {
    case ADJUSTMENT_STATUS.ADJUSTMENT_OK:
      // 軸調整OK表示画面に遷移
      self.phase = PHASE.SUCCESS;
      break;
    case ADJUSTMENT_STATUS.ADJUSTMENT_NG:
      // 軸調整NG表示画面に遷移
      self.phase = PHASE.ADJUSTMENT_NG;
      break;
    case ADJUSTMENT_STATUS.ADJUSTMENT_FAILED:
      // エラー画面に遷移
      self.phase = PHASE.FAILED;
      break;
    default:
      break;
  }
}